<div class="chip"
     cdkOverlayOrigin
     #chipOrigin="cdkOverlayOrigin"
     [class.chip--configured]="configured()"
     [class.chip--active]="active()"
     [class.chip--static]="static()"
     [attr.data-category]="meta().category"
     role="button"
     tabindex="0"
     (click)="onEdit()"
     (keydown.enter)="onEdit()"
     (keydown.space)="onEdit()">

  <!-- Category color dot -->
  <span class="chip-dot" [style.background]="categoryColor()"></span>

  <!-- Type icon -->
  <mat-icon class="chip-icon">{{ meta().icon }}</mat-icon>

  <!-- Label -->
  <span class="chip-label">{{ meta().labelKey | transloco }}</span>

  <!-- Status indicator -->
  @if (configured()) {
    <mat-icon class="chip-status chip-status--ok"
              [matTooltip]="'policyBuilder.status.configured' | transloco">
      check_circle
    </mat-icon>
  } @else {
    <mat-icon class="chip-status chip-status--pending"
              [matTooltip]="'policyBuilder.status.pending' | transloco">
      settings
    </mat-icon>
  }

  <!-- Remove / Lock -->
  @if (locked()) {
    <mat-icon class="chip-lock"
              [matTooltip]="'policyBuilder.status.mandatory' | transloco">
      lock
    </mat-icon>
  } @else {
    <button class="chip-remove"
            (click)="$event.stopPropagation(); remove.emit()"
            [attr.aria-label]="'Remove'">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
